import React, {PureComponent} from 'react';
import {DateTimePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {localized} from '../../../../state/i18n/i18n';

interface State {
  selectedDate?: Date | null;
}

type PropsFromParent = {
  callbackFromParent(Date: Date): void;
  selectedDateFromParent?: Date | null;
};

class DeviceDateTimePicker extends PureComponent<PropsFromParent, State> {
  constructor(Props: PropsFromParent) {
    super(Props);
    this.state = {
      selectedDate: this.setNullIfUndefined(),
    };
  }

  private setNullIfUndefined = () => {
    if (this.props.selectedDateFromParent === undefined) return null;
    else return this.props.selectedDateFromParent;
  };

  private onChange = (date: any) => {
    // It is nessasary to cast date to a Date due to the fact that DateTimePicker has a wrong Typescript implementation. The type indicated is MaterialUiPickersDate, but should have been a Date.
    let dateTyped = date as Date;
    if (dateTyped !== undefined && dateTyped !== null) {
      this.props.callbackFromParent(dateTyped);
      this.setState({selectedDate: dateTyped});
    }
  };

  componentDidUpdate = (prevProps: PropsFromParent) => {
    if (prevProps.selectedDateFromParent !== this.props.selectedDateFromParent) {
      this.setState({selectedDate: this.setNullIfUndefined()});
    }
  };

  public render() {
    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <DateTimePicker
          value={this.state.selectedDate}
          disablePast={false}
          disableFuture={true}
          onChange={this.onChange}
          label={localized('TimeOfMeasurement')}
          ampm={false}
          hideTabs={true}
          autoOk={false}
          variant="dialog"
        />
      </MuiPickersUtilsProvider>
    );
  }
}

export default DeviceDateTimePicker;
